export const defaultTheme = {};
export const ITEQ = 'ITEQ'

export const themes = {
  [ITEQ]: {
    palette: {
      primary: {
        main: '#06742e',
      }
    }
  }
}

const hosts = {
  'iteq.stackup.design': ITEQ,
  'www.iteq.stackup.design': ITEQ,
  'next.iteq.stackup.design': ITEQ,
};

export function getHost() {
  const hostname = window.location.hostname;
  console.log('hostname:', hostname); // eslint-disable-line no-console
  return hosts[hostname] || ITEQ;
}

export function getTheme() {
  const host = getHost();
  const theme = themes[host];

  return theme || defaultTheme;
}

export default getTheme;



// WEBPACK FOOTER //
// ./src/constants/themes.js